/* global angular */
import Debug from 'ace-ui/ace-debug';

const COMPONENT_NAME = 'AceUIAuth';

angular.module ('atex.aceui.authentication')
  .factory (COMPONENT_NAME, ['$uibModal', 'ApplicationConfigurationService', 'AuthenticationDialog', 'AuthenticationService',
    ($uibModal, ApplicationConfigurationService, AuthenticationDialog, AuthenticationService) => {

      let signingIn;
      const debug = new Debug (COMPONENT_NAME);

      const loginUsingAce = (currentUser) => {
        debug.log ('Login using aceLogin');
        let modal;
        if (currentUser !== undefined && currentUser.userId !== undefined) {
          modal = AuthenticationDialog.create({username: currentUser.username});

          return modal.whenAuthenticated().then(function (user) {
            AuthenticationService.confirmAuthenticationRequest(user);
          }, function () {
            AuthenticationService.cancelAuthenticationRequest();
          });
        } else {
          modal = AuthenticationDialog.create();

          return modal.whenAuthenticated().then(function (user) {
            AuthenticationService.confirmAuthenticationRequest(user);
          }, function (error) {
            console.log('ERROR: Login modal was cancelled. This cannot happen. ಠ_ಠ', error);
          });
        }
      };

      const loginUsingCognito = (currentUser, { loginUrl, clientId, redirectUri, scope, aceLoginEnabled }) => {
        debug.log ('Login using cognito');
        let user;
        const url = `${loginUrl}?client_id=${clientId}&redirect_uri=${redirectUri}&response_type=token&scope=${scope}`;

        if (currentUser && currentUser.userId) {
          user = currentUser.username || currentUser.userId;
        }

        const modal = $uibModal.open({
          animation: false,
          backdrop: 'static',
          keyboard: false,
          component: 'cognitoModal',
          windowClass: 'login-modal',
          resolve : {
            url: () => url,
            user: () => user,
            aceLoginEnabled: () => aceLoginEnabled
          }
        });

        return modal.result.then ((result) => {
          if (result.loginUsingAce) {
            loginUsingAce (currentUser);
          } else {
            AuthenticationService.confirmAuthenticationRequest(result.user);
          }
        });
      };

      return {
        signIn: (currentUser) => {
          return signingIn ? signingIn : signingIn = ApplicationConfigurationService.getConfigurationFor ('Authentication')
            .then ((conf) => {
              conf = conf || {};
              if (conf.method === 'cognito') {
                return loginUsingCognito (currentUser, conf.cognito);
              } else if (conf.method === 'ace' || conf.method === undefined) {
                return loginUsingAce (currentUser);
              }
            })
            .then (() => {
              signingIn = undefined;
            });  
        }
      };
    }]);